{"version":"0.6.0","sha":"1c60058","branch":"develop","env":"dev","builtAt":"2026-10-09T14:43:52.035Z"}